import { render, staticRenderFns } from "./layout_admin.vue?vue&type=template&id=2897547e&scoped=true"
import script from "./layout_admin.vue?vue&type=script&lang=js"
export * from "./layout_admin.vue?vue&type=script&lang=js"
import style0 from "./layout_admin.vue?vue&type=style&index=0&id=2897547e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897547e",
  null
  
)

export default component.exports